function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "Icon/Interface/Remove/32");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icons-**",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard",
  transform: "translate(-1020.000000, -5004.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1018.908856, 5002.125000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-156",
  x: 0,
  y: 0,
  width: 32,
  height: 32
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,2 C23.7,2 30,8.3 30,16 C30,23.7 23.7,30 16,30 C8.3,30 2,23.7 2,16 C2,8.3 8.3,2 16,2 Z M22.01104,14.74 L9.98,14.74 C9.28412122,14.74 8.72,15.3041212 8.72,16 C8.72,16.6958788 9.28412122,17.26 9.98,17.26 L22.01104,17.26 C22.7069188,17.26 23.27104,16.6958788 23.27104,16 C23.27104,15.3041212 22.7069188,14.74 22.01104,14.74 L22.01104,14.74 Z",
  id: "Shape",
  fill: "currentcolor"
}))));

const SvgResetMfa = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  style: {
    padding: "1.5px"
  },
  viewBox: "0 0 29 29",
  ref: svgRef
}, props), _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgResetMfa, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reset_mfa.5c860610.svg";
export { ForwardRef as ReactComponent };